function resetInputChildren(targetName) {
  var elem = document.getElementById("elusapps-option-detas");
  var data = elem !== null ? JSON.parse(elem.textContent) : [];
  var ctargets = document.getElementsByName(targetName);
  for (var i=0; i<ctargets.length; i++) {
    var ctarget = ctargets[i];
    var t = ctarget.type;
    var v = ctarget.value;
    var n = ctarget.name;

    if (t === "checkbox") {
      ctarget.checked = false;
    } else if (t === "radio") {
      ctarget.checked = false;
    } else {
      ctarget.value = "";
    }

    var set = data.find((d) => d.name === n);
    if (set !== undefined && set.children !== undefined) {
      var children = set.children;

      if (t === "checkbox") {
        var child = children.find((c) => c.value === v);
        if (child !== undefined) {
          var target = document.getElementById(child.target);
          resetInputChildren(child.name);
          target.classList.add('elusapps_hide');
          target.querySelectorAll('.elusapps_opt_input').forEach((input) => {
            input.disabled = true;
          });
        }

      } else if (t === "radio") {
        children.map((child) => {
          var target = document.getElementById(child.target);
          resetInputChildren(child.name);
          target.classList.add('elusapps_hide');
          target.querySelectorAll('.elusapps_opt_input').forEach((input) => {
            input.disabled = true;
          });
        });

      } else {
        children.map((child) => {
          var target = document.getElementById(child.target);
          resetInputChildren(child.name);
          target.classList.add('elusapps_hide');
          target.querySelectorAll('.elusapps_opt_input').forEach((input) => {
            input.disabled = true;
          });
        });
      }
    }
  }
}
function changeInput(event) {
  var elem = document.getElementById("elusapps-option-detas");
  var data = elem !== null ? JSON.parse(elem.textContent) : [];
  var current = event.currentTarget;
  var t = current.type;
  var v = current.value;
  var n = current.name;
  var set = data.find((d) => d.name === n);
  if (set !== undefined && set.children !== undefined) {
    var children = set.children;

    if (t === "checkbox") {
      var child = children.find((c) => c.value === v);
      if (child !== undefined) {
        var target = document.getElementById(child.target);
        if (current.checked) {
          target.classList.remove('elusapps_hide');
          target.querySelectorAll('.elusapps_opt_input').forEach((input) => {
            input.disabled = false;
          });
        } else {
          resetInputChildren(child.name);
          target.classList.add('elusapps_hide');
          target.querySelectorAll('.elusapps_opt_input').forEach((input) => {
            input.disabled = true;
          });
        }
      }

    } else if (t === "radio") {
      children.map((child) => {
        var target = document.getElementById(child.target);
        resetInputChildren(child.name);
        target.classList.add('elusapps_hide');
        target.querySelectorAll('.elusapps_opt_input').forEach((input) => {
          input.disabled = true;
        });
      });

      if (current.checked) {
        var child = children.find((c) => c.value === v);
        if (child !== undefined) {
          var target = document.getElementById(child.target);
          target.classList.remove('elusapps_hide');
          target.querySelectorAll('.elusapps_opt_input').forEach((input) => {
            input.disabled = false;
          });
        }
      }

    } else {
      children.map((child) => {
        var target = document.getElementById(child.target);
        resetInputChildren(child.name);
        target.classList.add('elusapps_hide');
        target.querySelectorAll('.elusapps_opt_input').forEach((input) => {
          input.disabled = true;
        });
      });

      var child = children.find((c) => c.value === v);
      if (child !== undefined) {
        var target = document.getElementById(child.target);
        target.classList.remove('elusapps_hide');
        target.querySelectorAll('.elusapps_opt_input').forEach((input) => {
          input.disabled = false;
        });
      }
    }

  } else {
    if (t === "checkbox") {
      if (current.classList.contains('is_quantity')) {
        var target = current.closest('.elusapps_check_option').nextElementSibling;
        if (current.checked) {
          target.classList.remove('elusapps_hide');
        } else {
          target.classList.add('elusapps_hide');
        }
      }
    }
  }
}

function setInputOptions() {
  var elem = document.getElementById("elusapps-option-detas");
  var data = elem !== null ? JSON.parse(elem.textContent) : [];
  if (elem === null) {
    document.querySelector('.elusapps_options_ttl_area').style.display = 'none';
  }
  var target = document.getElementById('elusapps-option-form-input');
  var htmldata = '';
  data.map((d, i) => {
    var cnt = i + 1;
    var required = d.required ? ' required' : '';
    var ischild = d.ischild ? ' elusapps_option_child elusapps_hide' : '';
    var disabled = d.ischild ? '  disabled' : '';
    var default_txt = d.title == 'ご希望お届け日' ? '配送希望日を選択してくだい' : '選択してください';
    var caption = d.caption ? '※'+d.caption : '';
    var isLabel = (d.label !== undefined && d.label == true) ? "" : "elusapps_hide";
    var placeholder = d.placeholder !== undefined ? d.placeholder : '絵文字はご使用いただけません。また、カート追加後の再編集はできませんので、カートに追加する前に再度内容をご確認ください。';
    htmldata += '\
    <div id="elusapps_option_'+cnt+'" class="elusapps_option'+ischild+'">\
      <div class="elusapps_option_name '+isLabel+'">\
        <div>'+d.title+'   :  </div>\
      </div>\
      <div class="elusapps_option_value">';
    if (d.type === 'checkbox' || d.type === 'radio' || d.type === 'select') {
      if (d.type === 'select') {
        htmldata += '<select class="elusapps_opt_input elusapps_full_width'+required+'" name="'+d.name+'" title="'+d.title+'"'+disabled+''+required+'><option value="">--'+ default_txt +'--</option>';
      }
      d.options.map((dc) => {
        var showquantity = dc.showquantity == undefined ? false : dc.showquantity;
        var price = '';
        var dtitle = dc.title == undefined ? d.title : dc.title;
        var ptitle = dtitle;
        var dcap = dc.caption ? '※'+dc.caption : '';
        if (dc.product !== undefined) {
          price = dc.product.price ? '(+¥'+dc.product.price+')' : '';
          ptitle = dtitle+price;
        } else {
          if (dc.price !== undefined) {
            price = dc.price ? '(+¥'+dc.price+')' : '';          
            ptitle = dtitle+price;
          } else {
            if (d.price_title !== undefined) {
              ptitle = d.price_title;
            }
          }
        }
        if (d.type === 'checkbox') {
          var dname = dc.name == undefined ? d.name : dc.name;
          var elusapps_check_option_cl = showquantity ? "is_quantity" : "";
          htmldata += '\
          <label class="elusapps_check_option">\
            <input type="checkbox" name="'+dname+'" value="'+dc.value+'" class="elusapps_opt_input'+required+' '+elusapps_check_option_cl+'" title="'+dtitle+'"'+disabled+''+required+'>\
            <div class="elusapps_option_label">'+ptitle+'</div>\
            <div class="elusapps_option_value_txt">'+dcap+'</div>\
          </label>';
          if (showquantity) {
            htmldata += '<div class="elusapps_option_quantity elusapps_hide">\
            <div class="elusapps_option_value_txt">数量</div>\
            <label class="elusapps_check_option">\
              <select name="opt_quantity" class="select_s elusapps_opt_input_quantity" data-target="'+dtitle+'">\
                <option value="1" selected>1</option>\
                <option value="2">2</option>\
                <option value="3">3</option>\
                <option value="4">4</option>\
                <option value="5">5</option>\
              </select>\
            </label>\
            </div>';
          }
        }
        if (d.type === 'radio') {
          htmldata += '\
          <label class="elusapps_radio_option">\
            <input type="radio" name="'+d.name+'" value="'+dc.value+'" class="elusapps_opt_input'+required+'" title="'+d.title+'"'+disabled+''+required+'>\
            <div class="elusapps_option_label">'+dc.value+price+'</div>\
            <div class="elusapps_option_value_txt">'+dcap+'</div>\
          </label>';
        }
        if (d.type === 'select') {
          htmldata += '<option value="'+dc.value+'">'+dc.value+'</option>';
        }
      });
      if (d.type === 'select') {
        htmldata += '</select>';
      }
      htmldata += '<div class="elusapps_option_value_txt">'+caption+'</div>';
    }
    if (d.type === 'textarea') {
      htmldata += '<div class="elusapps_option_value_txt">'+d.title+'</div>\
      <textarea class="elusapps_opt_input elusapps_full_width'+required+'" name="'+d.name+'" title="'+d.title+'"'+disabled+' placeholder="'+placeholder+'"'+required+'>'+d.options[0].value+'</textarea>\
      <div class="elusapps_option_value_txt">'+caption+'</div>\
      <div class="elusapps_option_value_txt">150 文字</div>';
    }
    htmldata += '\
      </div>\
    </div>';
  });
  target.innerHTML = htmldata;

  var elementList = document.querySelectorAll('.elusapps_opt_input');
  for (var i=0; i < elementList.length; i++) {
    var element = elementList[i];
    element.addEventListener('change', changeInput);
  }
}

setInputOptions();

window.addEventListener('load', function() {
  var op = document.querySelectorAll(".elusapps_opt_input");
  op.forEach(function(input) {
    if( input.type == "radio" || input.type == "checkbox") {
      input.checked = false;
    } else if (input.type == "select") {
      input.selectedIndex = 0;
    } else {
      input.value = '';
    }
  });
  var op2 = document.querySelectorAll(".elusapps_opt_input_quantity");
  op2.forEach(function(input) {
    if(input.type == "select") {
      input.selectedIndex = 0;
    }
  });
});

if (!customElements.get('elusapps-option-form')) {
  customElements.define('elusapps-option-form', class ElusappsProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onCheckInput() {
      var otionBoxs = document.querySelectorAll('.elusapps_option');
      var chkError = false;
      otionBoxs.forEach((otionBox) => {
        var isError = true;
        var formElements = otionBox.querySelectorAll('.elusapps_opt_input.required:not([disabled])');
        if (formElements.length > 0) {
          formElements.forEach((input) => {
            var t = input.type;
            if (t === "checkbox") {
              if(input.checked) {
                isError = false;
              }
            } else if (t === "radio") {
              if(input.checked) {
                isError = false;
              }
            } else {
              if(input.value !== "") {
                isError = false;
              }
            }
          });
        } else {
          isError = false;
        }
        if (isError) {
          otionBox.classList.add('is_error');
          chkError = true;
        } else {
          otionBox.classList.remove('is_error');
        }
      });
      return chkError;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      var elem = document.getElementById("elusapps-option-detas");
      var data = elem !== null ? JSON.parse(elem.textContent) : [];
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      if (this.onCheckInput()) return;

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const section = this.closest('section');
      if (!section) return;
  
      const productFormSection = section.querySelector('elusapps-option-form');
      if (!productFormSection) return;

      const productForm = productFormSection.querySelector('form');
      if (!productForm) return;
  
      const formData = new FormData(productForm);
      if (this.dataset.cartType != 'page') {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      const product = Object.fromEntries(formData);

      var formElements = document.forms.elusapps_options.elements;
      var quantityArr = [];
      for(var i=0;i < formElements.length;i++) {
        if (formElements[i].name && formElements[i].name === "opt_quantity") {
          var t = formElements[i].type;
          if (t === "checkbox") {
            if(formElements[i].checked) {
              quantityArr.push({
                "title": formElements[i].dataset.target,
                "opt_quantity": formElements[i].value
              })
            }
          } else if (t === "radio") {
            if(formElements[i].checked) {
              quantityArr.push({
                "title": formElements[i].dataset.target,
                "opt_quantity": formElements[i].value
              })
            }
          } else {
            if(formElements[i].value !== "") {
              quantityArr.push({
                "title": formElements[i].dataset.target,
                "opt_quantity": formElements[i].value
              })
            }
          }
        }
      }
      var arr = [];
      for(var i=0;i < formElements.length;i++) {
        if (formElements[i].classList.contains('elusapps_opt_input') == true ) {
          if (formElements[i].name && formElements[i].name !== "opt_quantity") {
            var t = formElements[i].type;
            var qdata = quantityArr.filter((q) => q.title == formElements[i].title);
            if (t === "checkbox") {
              if(formElements[i].checked) {
                var q = 1;
                if (qdata !== undefined) {
                  if (qdata[0] !== undefined) {
                    q = qdata[0].opt_quantity;
                  }
                }
                arr.push({
                  "name": formElements[i].name,
                  "value": formElements[i].value,
                  "title": formElements[i].title,
                  "opt_quantity": q
                })
              }
            } else if (t === "radio") {
              if(formElements[i].checked) {
                arr.push({
                  "name": formElements[i].name,
                  "value": formElements[i].value,
                  "title": formElements[i].title,
                  "opt_quantity": q
                })
              }
            } else if (t === "text" || t === "textarea" || t === "select" || t === "select-one") {
              if(formElements[i].value !== "") {
                arr.push({
                  "name": formElements[i].name,
                  "value": formElements[i].value,
                  "title": formElements[i].title,
                  "opt_quantity": q
                })
              }
            }
          }
        }
      }

      let min = 1000;
      let max = 9999;
      var code = Math.floor( Math.random() * (max + 1 - min) ) + min;
      if (arr.length > 0) {
        let addData = {
          'items': []
        }
        let properties = {};
        properties['Option Code'] = product.id+'-'+code;

        for(var j=0;j < arr.length;j++) {
          var pquantity = parseInt(document.querySelector('input[name="quantity"]').value);
          var optData = data.find((d) => d.name === arr[j].name);
          var optQuantity = arr[j].opt_quantity * pquantity;
          var opt = {};
          for(var k=0;k < optData.options.length;k++) {
            var option = optData.options[k];
            if (option.value === arr[j].value) {
              opt = option;
            }
          }
          if (opt.product !== undefined) {
            var adata = {
              'id': opt.product.id,
              'quantity': optQuantity,
              'properties': {
                'Type': 'Option',
                'Option Code': product.id+'-'+code
              }
            };
            addData['items'].push(adata);
          }
          properties[arr[j].title] = arr[j].value;
        }

        addData['items'].push({
          'id': product.id,
          'quantity': pquantity,
          'properties': properties
        });

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(addData)
        })
        .then((response) => response.json())
        .then((response) => {
          window.location = '/cart/';
          return;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.finallyEvent();
        });

      } else {

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          this.responseEvent(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.finallyEvent();
        });
      }
    }

    responseEvent(response) {
      if (response.status) {
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      } else if (this.dataset.cartType == 'page') {
        window.location = '/cart/';
        return;
      }

      window.location = '/cart/';
      return;

      this.error = false;
      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener('modalClosed', () => {
          setTimeout(() => { this.cart.renderContents(response) });
        }, { once: true });
        quickAddModal.hide(true);
      } else {
        this.cart.renderContents(response);
      }
    }

    finallyEvent() {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

